var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 8.53125L7.28125 13.7695C7.10547 13.9453 6.85938 13.9453 6.68359 13.7695L1.48047 8.53125C1.30469 8.39062 1.30469 8.10938 1.48047 7.93359L1.72656 7.6875C1.90234 7.54688 2.14844 7.54688 2.32422 7.6875L6.40234 11.7656V0.796875C6.40234 0.585938 6.57812 0.375 6.82422 0.375H7.17578C7.38672 0.375 7.59766 0.585938 7.59766 0.796875V11.7656L11.6406 7.6875C11.8164 7.54688 12.0625 7.54688 12.2383 7.6875L12.4844 7.96875C12.6602 8.10938 12.6602 8.39062 12.4844 8.53125ZM13.75 15.7031C13.75 15.9492 13.5391 16.125 13.3281 16.125H0.671875C0.425781 16.125 0.25 15.9492 0.25 15.7031V15.4219C0.25 15.2109 0.425781 15 0.671875 15H13.3281C13.5391 15 13.75 15.2109 13.75 15.4219V15.7031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c9499e1b.svg";
export { ForwardRef as ReactComponent };